import { useFormatMessage } from "@comparaonline/react-intl-hooks";
import dynamic from "next/dynamic";
import { WithRouterProps } from "next/router";
import React from "react";

import { AppContext } from "../../../../lib/appContext";
import { useRouter } from "../../../../lib/routerContext";
import { Container } from "./Container";
import { linkBuilder } from "./linkBuilder";
import { Pagination as PaginationComponent } from "./Pagination";

interface PaginationProps extends WithRouterProps {
  page: number;
  totalPages: number;
}

const DefaultPages = dynamic(() => import("./Pagination/Pages/DefaultPages"));
const CompactPages = dynamic(() => import("./Pagination/Pages/CompactPages"));

export const Pagination: React.FC<PaginationProps> = ({ page, totalPages }) => {
  const router = useRouter();
  const { isMobile } = React.useContext(AppContext);
  const formatMessage = useFormatMessage();
  const message = formatMessage("pagination.pageOf", {
    currentPage: page,
    totalPages
  });
  return (
    <Container>
      <PaginationComponent
        compactMessage={message}
        compactSteps={!isMobile}
        currentPage={page}
        totalPages={totalPages}
        PagesComponent={isMobile ? CompactPages : DefaultPages}
        LinkComponent={linkBuilder(router)}
      />
    </Container>
  );
};
